import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { instantAccessItems } from '../data/curriculum';
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-95" data-mp="1mg3p1kt5mvdi">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-96" data-mp="1hnu2mer90dfz">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-amber/15 text-brand-amber" data-id="element-97" data-mp="1hm982p4xoui4">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-98" data-mp="1reeyhufjf3v7" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-99" data-mp="1rg84r8m8nm2o">⚡ Cosa Ottieni Subito?</h2>
        <div className="space-y-3 text-left" data-id="element-100" data-mp="20ek6o6sk26af">
          {instantAccessItems.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-101" data-mp="20cr0esluto2y">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-green" aria-hidden="true" data-id="element-102" data-mp="623vcrkwk1yp" />
              <span className="font-semibold" data-id="element-103" data-mp="2n386pbo6cti1">{item}</span>
            </div>)}
        </div>
        <CTAButton className="mt-10" data-id="element-104" data-mp="2s11eg954lvkf">OTTIENI BIOLOGIA PRONTA ORA</CTAButton>
      </Reveal>
    </section>;
}